module.exports = __webpack_public_path__ + "img/comment_locked_36.910bcada.svg";